/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconGps = createReactComponent("outline", "gps", "IconGps", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 17l-1 -4l-4 -1l9 -4z", "key": "svg-1" }]]);

export { IconGps as default };
//# sourceMappingURL=IconGps.mjs.map
